<div fxLayout="row">
  <abc-button
    stylingMode="text"
    [ngClass]="frame?.rtlEnabled ? 'icon_rtl' : ''"
    class="nav-left-btn"
    [icon]="res.svgUrl('Navigation-ArrowLeft-Image')"
    [disabled]="isNavDisabled('decrement')"
    (onClick)="worksService.navigateContext(-1)"
  >
  </abc-button>

  <abc-button
    stylingMode="text"
    [ngClass]="frame?.rtlEnabled ? 'icon_rtl' : ''"
    class="nav-right-btn"
    [icon]="res.svgUrl('Navigation-ArrowRight-Image')"
    [disabled]="isNavDisabled('increment')"
    (onClick)="worksService.navigateContext(1)"
  >
  </abc-button>
</div>
